import BaseEntity from '../../base/BaseEntity.model';

export default class SolicitudAfiliacionTitular extends BaseEntity {
    public tramiteBeneficiarioId?: number;
    public personaId?: number;
    public nombre?: string;
    public apellido?: string;
    public email?: string;
    public telefono?: string;
    constructor(public cedula: string) {
        super();
        this.tramiteBeneficiarioId = undefined;
        this.personaId = undefined;
        this.nombre = undefined;
        this.apellido = undefined;
        this.email = undefined;
        this.telefono = undefined;
    }
}